import React from 'react';
// import AppBar from '@mui/material/AppBar';
// import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
// import Button from '@mui/material/Button';
import govemblem from '../images/govemblem.png';
import { Link, Element } from 'react-scroll';
import Button from '@mui/material/Button';
import { HashLink } from 'react-router-hash-link';

// import Toggle from "./components/Toggle";

import "./NavBar.css";

const navbar = () => {
    return (
        <div className="n-wrapper" id="Navbar">
            {/* left */}
            <div className="n-left">
                <img
                    src={govemblem}
                    alt="Your Image"
                    style={{ width: '40px', height: '60px',marginTop: '25px' , marginLeft: '30px' }}
                />
                <div className="n-name">
                    Nyaya Saarathi <br></br> <span>ન્યાય સારથી</span>
                </div>
                
                {/* <Toggle /> */}
            </div>
            {/* right */}
            <div className="n-right">
                <div className="n-list">
                    <ul style={{ listStyleType: "none" }}>
                        <li>
                            
                            <Link activeClass="active" to="Navbar" spy={true} smooth={true}>
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link to="Coming" spy={true} smooth={true}>
                                GP/PP 
                                {/* Government Pleader / Public Prosecutor */}


                            </Link>
                        </li>
                        <li>
                            <Link to="HowItWorks" spy={true} smooth={true}>
                                AGP/App 
                                {/* Assistant Government Pleader  / Public Procecutor */}
                            </Link>
                        </li>
                        
                    </ul>
                </div>
                <button class="normal-button">Login</button>
            </div>
        </div>
    );
};


export default navbar;
